module.exports = __webpack_public_path__ + "static/media/YM47_4.94a325a3.jpg";